import React from 'react';
import {useTranslation} from 'react-i18next';
import {View} from 'react-native';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import {useHistory} from '../../../../../imports/Router';
import Step from '../step/Step.component';
import styles from './StepHeader.style';

export default function StepHeader(props) {
  const {numberOfPoints, activeIndex, cancelable} = props;
  const history = useHistory();
  const {t} = useTranslation();

  return (
    <View
      style={[
        styles.container,
        {
          justifyContent: cancelable ? 'space-between' : 'flex-end',
        },
      ]}>
      {cancelable && (
        <PrimaryButton
          title={t('cancel')}
          outline
          textStyle={styles.buttonText}
          containerStyle={styles.buttonContainer}
          onPress={() => {
            history.replace('/register/info');
          }}
        />
      )}
      <Step {...props} />
    </View>
  );
}
